import React, { useState, useEffect } from "react";

const CountDownTimer = ({ targetDate, type, remTime }) => {
  const calculateTimeLeft = () => {
    const difference = +targetDate - +new Date();
    let timeLeft = remTime || {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    if (difference <= 0) {
      timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [bidExpired, setBidExpired] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const updatedTimeLeft = calculateTimeLeft();
      setTimeLeft(updatedTimeLeft);
      if (
        updatedTimeLeft.days === 0 &&
        updatedTimeLeft.hours === 0 &&
        updatedTimeLeft.minutes === 0 &&
        updatedTimeLeft.seconds === 0
      ) {
        setBidExpired(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  return (
    <>
      <div className="countdown">
        {bidExpired ? (
          <div className="bid-expired">Expired!</div>
        ) : (
          <>
            {type === "2" ? (
              <div className="counter-container2">
                <div className="countdown-item2">
                  <div>{timeLeft.days}</div>
                  <div>Days</div>
                </div>
                <div className="countdown-item2">:</div>
                <div className="countdown-item2">
                  <div>{timeLeft.hours}</div>
                  <div>Hr</div>
                </div>
                <div className="countdown-item2">:</div>
                <div className="countdown-item2">
                  <div>{timeLeft.minutes}</div>
                  <div>Min</div>
                </div>
                <div className="countdown-item2">:</div>
                <div className="countdown-item2">
                  <div>{timeLeft.seconds}</div>
                  <div>Sec</div>
                </div>
              </div>
            ) : (
              <>
                <div className="countdown-item">
                  <div>{timeLeft.days}</div>
                  <div>Days</div>
                </div>
                <div className="countdown-item">:</div>
                <div className="countdown-item">
                  <div>{timeLeft.hours}</div>
                  <div>Hours</div>
                </div>
                <div className="countdown-item">:</div>
                <div className="countdown-item">
                  <div>{timeLeft.minutes}</div>
                  <div>Minutes</div>
                </div>
                <div className="countdown-item">:</div>
                <div className="countdown-item">
                  <div>{timeLeft.seconds}</div>
                  <div>Seconds</div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default CountDownTimer;
